export default "__VITE_ASSET__MkN1wHS6__"